import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { CoreModule } from "src/app/core/core.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { LearnAudioComponent } from "./learn-audio.component";
import { LearnQuestionAnswerModule } from "../learn-question-answer/learn-question-answer.module";
import { TablerIconComponent } from "angular-tabler-icons";

@NgModule({
  declarations: [
    LearnAudioComponent,
  ],
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    SharedModule,
    CoreModule,
    TranslateModule,
    LearnQuestionAnswerModule,
    TablerIconComponent
  ],
  exports: [
    LearnAudioComponent
  ]
})
export class LearnAudioModule { }